/* esm.sh - rxjs@7.8.2/dist/esm/internal/operators/switchMapTo */
import{switchMap as t}from"rxjs/dist/esm/internal/operators/switchMap";import{isFunction as p}from"rxjs/dist/esm/internal/util/isFunction";function f(o,i){return p(i)?t(()=>o,i):t(()=>o)}export{f as switchMapTo};
//# sourceMappingURL=switchMapTo.mjs.map